import React from "react";
import { OtpInput } from "reactjs-otp-input";

const InputForOtp = ({
  value,
  onChange,
  numInputs = 6,
  shouldAutoFocus = true,
  inputStyle = {
    fontSize: "24px",
    width: "30px",
    height: "30px",
    margin: "4px",
    borderTop: "0px",
    borderLeft: "0px",
    borderRight: "0px",
    outline: "none",
    borderColor: "#000",
  },
  containerStyle = {
    margin: "20px auto",
    padding: "10px",
  },
}) => {
  return (
    <OtpInput
      value={value}
      onChange={onChange}
      numInputs={numInputs}
      isInputNum
      shouldAutoFocus={shouldAutoFocus}
      inputStyle={inputStyle}
      containerStyle={containerStyle}
      className="otp_number input_font"
    />
  );
};

export default InputForOtp;
